import { render, staticRenderFns } from "./SearchArea.vue?vue&type=template&id=33a4ad89"
import script from "./SearchArea.vue?vue&type=script&lang=js"
export * from "./SearchArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/wp-content/themes/svea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33a4ad89')) {
      api.createRecord('33a4ad89', component.options)
    } else {
      api.reload('33a4ad89', component.options)
    }
    module.hot.accept("./SearchArea.vue?vue&type=template&id=33a4ad89", function () {
      api.rerender('33a4ad89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/SearchArea.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SearchArea.vue
// module id = 141
// module chunks = 0